import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;

  color: ${({ theme }) => theme.colors.orange.primary};

  height: 238px;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.white};

  box-shadow: ${({ theme }) => theme.shadow.default};
  border-radius: 12px;

  > div {
    width: 100%;
  }

  .legendContainer {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h3 {
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 16px;
    }

    .lines {
      display: flex;
      flex-direction: column;
      row-gap: 8px;

      div {
        display: flex;
        align-items: center;
        gap: 8px;

        div {
          width: 30px;
          height: 6px;
          border-radius: 3px;
        }

        p {
          font-weight: 400;
          font-size: 14px;
          color: ${({ theme }) => theme.colors.gray[600]};
          position: relative;
        }
      }
    }
  }
`;
